import React from 'react';

// "Sign in": never folds, stays in the bar for logged-out visitors.
export const SignInLink = () => (
  <a
    className='dcgreen'
    style={{ color: 'var(--primary)' }}
    href="/users/sign_in/"
    target="_blank"
    rel="noopener noreferrer"
  >
    {l.sign_in}
  </a>
);

// "or create an account": folds into the overflow menu when the bar runs out of room.
export const CreateAccountLink = () => (
  <span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    <span style={{ color: 'var(--sidebar-foreground)' }}>{l.or}</span>
    <a
      className='dcorange'
      style={{ color: 'var(--chart-4)' }}
      href="/users/sign_up"
      target="_blank"
      rel="noopener noreferrer"
    >
      {l.create_an_account}
    </a>
  </span>
);

const AuthLinks = ({ }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <SignInLink />
      <CreateAccountLink />
    </div>
  );
};

export default AuthLinks;
